import React from 'react';
import { CurrencyEur } from 'phosphor-react';
import { formatPrice } from '@sluitstraat/core';
import { commonStyles } from '../styles/commonStyles';
import { Spinner } from './Spinner';

interface AmountBadgeProps {
  /** Amount in euros (null renders the empty placeholder). */
  amount: number | null;
  /** True while a recalc is in flight — shows a spinner instead. */
  calculating?: boolean;
  /** Optional label shown before the amount (e.g. "Totaal"). */
  prefix?: string;
  /** 'total' = large header badge, 'price' = smaller row badge, 'highlight' = base-coverage box badge. */
  variant?: 'total' | 'price' | 'highlight';
}

const VARIANTS = {
  total: { style: commonStyles.coverageOptionsTotalBadge, glyph: 20 },
  price: { style: commonStyles.coverageOptionsPriceBadge, glyph: 17 },
  highlight: { style: commonStyles.baseCoverageBadge, glyph: 17 },
} as const;

export const AmountBadge: React.FC<AmountBadgeProps> = ({
  amount,
  calculating = false,
  prefix,
  variant = 'price',
}) => {
  const { style, glyph } = VARIANTS[variant];

  return (
    <span style={style}>
      {calculating ? (
        <Spinner size={glyph} />
      ) : amount != null && amount > 0 ? (
        `${prefix ? `${prefix}: ` : ''}€${formatPrice(amount)}`
      ) : (
        <>
          <CurrencyEur size={glyph} weight="bold" />
          <span>—</span>
        </>
      )}
    </span>
  );
};

export default AmountBadge;
